import { useState } from 'react';
import { View, Text } from 'react-native';
import theme from '../../../theme';
import Nav from '../Nav';
import { Footer } from '../Footer';
import AgentsDocsArticle from './AgentsDocsArticle';

const AgentsDocs = (props) => {

    return (
        <View style={{ width: '100%', backgroundColor: theme.colors.surfacePage }}>

            <Nav/>
            <Section style={{ borderBottomWidth: 1, borderBottomColor: theme.colors.borderDefault }} />

            <AgentsDocsArticle/>            

            <Footer/>

        </View>
    )

}

const Section = ({ style, children }) => (
  <View style={[{ width: '100%' }, style]}>{children}</View>
);

export default AgentsDocs